<!--

Copyright Paul B. Lucas (C) 2024   ALL RIGHTS RESERVED.
Licensed to the University of Illinois Urbana Champaign

This component is a subordinate component which  renders a common footer
containing legal notices and about information.

Revisions:
    12-17-2024      pblucas     initial creation

-->

<template>
  <div class="_unit_foot">
    <hr class="_blue_bar" />
    <p class="_p_app_title">
      Asset Manager
    </p>
    <div class="_container_address">
      <p class="_p_address">
        1211 Digital Computer Lab <br />
        1304 W. Springfield Ave. <br />
        Urbana, IL 61801<br />
        <br />
        <i>email: </i>consult@illinois.edu<br />
      </p>
    </div>
      <p class="_p_unit">
        <a class="_uiuc_link" href="https://techservices.illinois.edu/" target="_blank">
          Technology Services at Illinois
        </a>
      </p>
      
    <hr class="_org_bar" />
    <div class="_uiuc_foot">
      <a class="_uiuc_link" href="https://illinois.edu" target="_blank">
        <img class="_watermark" src="@/assets/Illinois_primary_wordmark_reversed_orange_rgb.png" > 
      </a>
      <br /><br />
      <div class="_notices" v-if="bShowLegal">
          <br />
          <p class="_p_notices" >
            The sample identities used in user documentation and in the Equipment Loan Agreement<br /> 
            Manager application are used under the “fair use” provision, §107 of the<br /> 
            Copyright Act (17 USC 110(i)) as non-commercial educational use with minor <br />
            substantiality and no commercial impact to copyright holder.	<br /><br />

            Ref: <a class="_legal_link" href="permissions@marvel.com">permissions@marvel.com</a>
          <br /><br />
        </p>
        <button class="_closer" 
          aria-label="Button to close legal notice"
          @click="bShowLegal = false" 
          @keydown.enter="bShowLegal=false">
          Ok
        </button>
      </div>
      <div class="_notices" v-if="bShowCopyright">
          <p class="_p_notices">
            <br /><br />
            This website Copyright (c) 2025 Paul B. Lucas ALL RIGHTS RESERVED.  Licensed to University of Illinois.
            <br /><br />
          </p>
          <button class="_closer" 
          aria-label="Button to close legal notice"
          @click="bShowCopyright = false" 
          @keydown.enter="bShowCopyright=false">
          Ok
        </button>
      </div>
      <div class="_link_container">

          <div class="_col_24" style="order: 1;">
            <a class="_reflink" @click.prevent="bShowCopyright=true">Copyright</a>
          </div>
          <div class="_col_24" style="order: 2;">
            <a class="_reflink" href="https://www.vpaa.uillinois.edu/resources/web_privacy" target="_blank">Privacy</a>
          </div>
          <div class="_col_24" style="order: 3;">
            <a class="_reflink" href="https://illinois.edu/resources/website/accessibility.html" target="_blank">Accessibility</a>
          </div>
          <div class="_col_24" style="order: 4;">
            <a class="_reflink" @click.prevent="bShowLegal=true">Legal</a>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'UIUCFooter',
  emits: [
  ],
  data()  {
    return {
      bShowLegal: false,
      bShowCopyright: false
    }
  }
 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  ._unit_foot {
    /* width: 100%; */
    min-height: 50px;
    background-color:#E8E9EB;
    margin: 0;
    padding: 0;
  }
  ._uiuc_foot {
    /* width: 100%; */
    min-height: 50px;
    background-color:#13294B;
    margin: 0;
    padding: 0;
  }
  ._p_app_title {
      font-family:Monserrat, Avenir, Helvetica, Arial, sans-serif;
      font-size: 13pt;
      color: #13294B;
      font-style: normal;
      font-weight: bold;
      margin: 0 0 0 60px;
      padding: 0 5px;
    }
  ._p_unit {
      font-family:Monserrat, Avenir, Helvetica, Arial, sans-serif;
      font-size: 13pt;
      font-style: normal;
      font-weight:normal;
      margin: 3px 0 0 60px;
      padding: 5px;
    }
    ._container_address {
        margin: 0;
        padding: 2px;
    }
    ._p_address {
      font-family:Monserrat, Avenir, Helvetica, Arial, sans-serif;
      font-size: 10pt;
      font-style: normal;
      font-weight:normal;
      line-height: 130%;
      margin: 3px 0 0 60px;
      padding: 5px;
    }
  ._org_bar {
      /* width: 99%; */
      border: 5px solid #FF5F05;
      margin:0;
      padding: 0;
  }
  ._blue_bar {
      /* width: 99%; */
      border: 5px solid #13294B;
      margin:0;
      padding: 0;
  }
  ._watermark {
      position: relative;
      height: 30px;
      /* left: 60px; */
      margin: 10px 0 0 60px;

    }
  ._uiuc_link {
    color: #13294B;
    text-decoration: none;
  }
  ._uiuc_link:hover {
    color: #FF5F05;
    text-decoration: none;
  }
  ._reflink {
    color: white;
    font-size: 0.8em;
    text-decoration: none;
  }
  ._reflink:hover { 
    color: #FF5F05;
    text-decoration: none;
  }
  ._legal_link {
    color: white;
    text-decoration: none;
  }
  ._legal_link:hover {
    color: #FF5F05;
    text-decoration: none;
  }
  ._link_container {
        order: 1;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        font-family:Monserrat, Avenir, Helvetica, Arial, sans-serif;
        text-decoration: none;
        margin: 0;
        padding: 15px 120px;
    }
    ._notices {
      min-height: 50px;
    }
    ._p_notices {
        order: 2;
        font-family: Monserrat, Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: white;
        font-size: .9em;
        font-weight: normal;
        margin: 0;
        padding: 10px 60px;
    }
    ._closer {
        border-style: solid;
        border-width: 2px;
        border-color: #13294B;
        border-radius: 4px;
        background-color: #E8E9EB;
        color: #13294B;
        font-weight: bold;
        padding: 2px 8px;
        margin: 5px 0 0 60px;
    }
    ._closer:hover {
        background-color: #FF5F05;
        color: white;
    }
    ._col_24 {
      width: 24%;
      margin: 0;
      padding: 0 ;
    }
    @media screen and (max-width: 800px) {
        ._link_container {
            flex-wrap: wrap;  
        }
        ._col_24 {
            width: 100%;
            
        }
    }
    @media screen and (max-width: 620px) {
        
        ._col_24 {
            width: 100%;
            padding: 5px 0;
        }

    }
</style>
